import { render } from "./ScheduleShow.vue?vue&type=template&id=6f6064fa&scoped=true"
import script from "./ScheduleShow.vue?vue&type=script&lang=js"
export * from "./ScheduleShow.vue?vue&type=script&lang=js"

import "./ScheduleShow.vue?vue&type=style&index=0&id=6f6064fa&lang=css"
import "./ScheduleShow.vue?vue&type=style&index=1&id=6f6064fa&scoped=true&lang=css"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f6064fa"]])

export default __exports__